import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getItemFromStorage } from '@utils/storage'

const PrivateRoute = ({ children, component: Component, ...rest }) => {
  const token = getItemFromStorage('token') || null

  return (
    <Route
      {...rest}
      render={props =>
        token ? <Redirect to="/main" /> : <Component {...props} />
      }
    />
  )
}

export default PrivateRoute
